"use client"

import { Zap } from "lucide-react"

interface PowerIndicatorProps {
  isPowered: boolean
}

export function PowerIndicator({ isPowered }: PowerIndicatorProps) {
  return (
    <div className="flex items-center gap-1.5">
      <Zap className={`size-3.5 shrink-0 ${isPowered ? "text-emerald-400" : "text-red-400"}`} />
      <span className="text-[10px] font-semibold text-muted-foreground uppercase tracking-wider">
        Power
      </span>
      <span
        className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[10px] font-mono font-semibold border ${
          isPowered
            ? "bg-emerald-500/15 text-emerald-500 dark:text-emerald-400 border-emerald-500/25"
            : "bg-red-500/15 text-red-500 dark:text-red-400 border-red-500/25"
        }`}
      >
        <span
          className={`size-1.5 rounded-full shrink-0 ${
            isPowered ? "bg-emerald-400 animate-pulse" : "bg-red-400"
          }`}
        />
        {isPowered ? "ON" : "OFF"}
      </span>
    </div>
  )
}
